// extracted by mini-css-extract-plugin
export default {"root":"ask-panda-button_root__xOUp6","shake":"ask-panda-button_shake__cgslt"};